<template>
  <nav class="paginator bg-gray-200 py-4 px-4 sm:px-12 border-t border-gray-400">
    <div class="paginator-left">
      <Link
        :href="pageLink(prevPage)"
        type="button"
        :disabled="!hasPrevPage"
        class="btn btn-secondary-outline"
      >
        <ChevronLeftIcon
          class="h-5 w-5"
          aria-hidden="true"
        />
        Previous
      </Link>
    </div>
    <div class="paginator-pages flex gap-x-2">
      <Link
        v-if="showFirstPage"
        :href="pageLink(firstPage)"
        class="btn btn-secondary-outline"
      >
        {{ firstPage }}
      </Link>
      <span
        v-if="showPrePageLinkEllipsis"
        class="border-transparent text-gray-600 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium"
      >
        ...
      </span>
      <Link
        v-for="pageNum in prePageNums"
        :href="pageLink(pageNum)"
        class="btn btn-secondary-outline"
      >
        {{ pageNum }}
      </Link>
      <Link
        :href="pageLink(page)"
        class="btn btn-primary"
      >
        {{ page }}
      </Link>
      <Link
        v-for="pageNum in postPageNums"
        :href="pageLink(pageNum)"
        class="btn btn-secondary-outline"
      >
        {{ pageNum }}
      </Link>
      <span
        v-if="showPostPageLinkEllipsis"
        class="border-transparent text-gray-600 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium"
      >
        ...
      </span>
      <Link
        v-if="showLastPage"
        :href="pageLink(lastPage)"
        class="btn btn-secondary-outline"
      >
        {{ lastPage }}
      </Link>
    </div>
    <div class="paginator-right">
      <Link
        :href="pageLink(nextPage)"
        type="button"
        :disabled="!hasNextPage"
        class="btn btn-secondary-outline"
      >
        Next
        <ChevronRightIcon
          class="h-5 w-5"
          aria-hidden="true"
        />
      </Link>
    </div>
  </nav>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/solid'
import toUrl from '@/Filters/QueryParams'

export default {
  components: {
    Link,
    ChevronLeftIcon,
    ChevronRightIcon
  },

  props: {
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 20
    },
    pageParamName: {
      type: String,
      required: false,
      default: function () {
        return 'page'
      }
    },
    routeName: {
      type: String,
      required: false,
      default: function () {
        return null
      }
    },
    path: {
      type: String,
      required: false,
      default: function () {
        return null
      }
    },
    params: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    }
  },

  computed: {
    pageSliceLength() {
      return 4
    },
    pageCount() {
      return Math.ceil(this.total / this.perPage)
    },
    pageRange() {
      return _.range(1, this.pageCount + 1)
    },
    currentPage() {
      return this.page
    },
    firstPage() {
      return _.first(this.pageRange)
    },
    lastPage() {
      return _.last(this.pageRange)
    },
    prePageNums() {
      return _.reverse(
        _.slice(_.reverse(_.partition(this.pageRange, (n) => n < this.page)[0]), 0, this.pageSliceLength)
      )
    },
    postPageNums() {
      return _.slice(_.partition(this.pageRange, (n) => n > this.page)[0], 0, this.pageSliceLength)
    },
    showFirstPage() {
      return _.first(this.prePageNums) !== this.firstPage && this.currentPage !== this.firstPage
    },
    showLastPage() {
      return _.last(this.postPageNums) !== this.lastPage && this.currentPage !== this.lastPage
    },
    showPrePageLinkEllipsis() {
      return this.showFirstPage
    },
    showPostPageLinkEllipsis() {
      return this.showLastPage
    },
    hasPrevPage() {
      return this.prevPage !== this.page
    },
    prevPage() {
      return Math.max(this.page - 1, 1)
    },
    hasNextPage() {
      return this.nextPage !== this.page
    },
    nextPage() {
      return Math.min(this.page + 1, this.pageCount)
    }
  },

  methods: {
    pageLink(page) {
      if (!this.routeName && !this.path) {
        return ''
      }

      let params = _.clone(this.params)
      params.page = page

      if (this.routeName) {
        return route(this.routeName, params)
      }

      const url = new URL(this.path)

      const paramsToUrl = toUrl(params)
      return url.toString() + '?' + paramsToUrl

      // for (var i in params) {
      //     url.searchParams.set(i, this.params[i] || '');
      // }
      //
      // url.searchParams.set(this.pageParamName, page);
      //
      // return url.toString();
    }
  }
}
</script>
